import React, { Fragment } from 'react';
import Message from 'legacy/src/utility/Message';
import EditMetadataSimple from './EditMetadataSimple';

const TagsEditor = ({
  isEdit,
  subjectInfo,
  tags,
  updateTags,
  showValidation,
  validations = {},
  questionType = null,
  flattenHierarchy,
  twoLevelQBFilterFF,
}) => {
  if (!isEdit) {
    return null;
  }

  return (
    <Fragment>
      <Message>
        Required Keyword Tags appear on reports for you and your students, and
        will help you filter and find this question later.
      </Message>

      {showValidation && !validations.hasAllRequiredTagsSelected && (
        <Message className="--error">
          In order to publish a question, you must select at least one tag from
          each of the <strong>Required Keyword Tags</strong> filters below.
        </Message>
      )}

      <EditMetadataSimple
        subjectInfo={subjectInfo}
        updateTags={updateTags}
        tags={tags}
        questionType={questionType}
        flattenHierarchy={flattenHierarchy}
        twoLevelQBFilterFF={twoLevelQBFilterFF}
      />
    </Fragment>
  );
};

export default TagsEditor;
